import React from 'react';
import {Divider} from 'antd';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, pic, author, cata, brief}) => (
<div style={{
    height: '116px',
    width:'100%',
    position: 'relative',
}}>
    <Link to={`/book/detail/${novel_id}`}>
        <img alt='' src={pic} style={{
            height: '116px',
            width: '90px',
            float: 'left',
        }}/>
        <div style={{
            position: 'relative',
            marginLeft: '100px',
            width:'100%'
        }}>
            <div style={{
                fontSize: '16px',
                lineHeight: '22px',
                color: '#333333',
            }}>
                <LinesEllipsis maxLine={1} text={name}/>
            </div>
            <div style={{
                margin: '4px 0',
                fontSize: '14px',
                lineHeight: '20px',
                color: '#999999',
            }}>
            {cata}{author && <span><Divider type="vertical" />{author}</span>}
            </div>
            <div style={{
                fontSize: '14px',
                lineHeight: '20px',
                color: '#333',
            }}>
				<LinesEllipsis text={brief} maxLine={3} />
            </div>
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_12.js